import React, { useState } from 'react';
import cn from 'classnames';
import { ClosedEye, Eye, Search } from '@/components/Svg';
import styles from './Input.module.scss';

export interface IInputProps {
  label?: string;
  placeholder: string;
  name: string;
  value?: any;
  onChange?: any;
  type?: string;
  required?: boolean;
  style?: any;
  pattern?: string;
  min?: number;
  max?: number;
  className?: string;
  onKeyDown?: any;
  onBlur?: any;
  onFocus?: any;
}

const Input = (props: IInputProps) => {
  const { label, onKeyDown, placeholder, name, value, onChange, type, pattern, min, max, className = '', onBlur, style, onFocus } = props;

  const [showPassword, setShowPassword] = useState(false);

  return (
    <>
      <div
        className={styles.wrapper}
        // style={style}
      >
        <label htmlFor={name}>{label}</label>
        {name === 'search' ? (
          <div className='relative'>
            <input
              required
              id={name}
              style={props.style}
              placeholder={placeholder}
              name={name}
              value={value}
              onChange={onChange}
              type={type}
              pattern={pattern}
              min={min}
              onKeyDown={onKeyDown}
              max={max}
              onBlur={onBlur}
              onFocus={onFocus}
              className={cn(className, styles.searchInput)}
              autoComplete='off'
            />
            <div className='absolute top-[35%] left-3 w-[15px] h-[15px]'>
              <Search width='100%' height='100%' />
            </div>
          </div>
        ) : type === 'password' ? (
          <div className='flex gap-1 justify-center items-center relative'>
            <input
              required
              id={name}
              style={props.style}
              placeholder={placeholder}
              name={name}
              value={value}
              onChange={onChange}
              type={showPassword ? 'text' : 'password'}
              pattern={pattern}
              min={min}
              max={max}
              className={className}
              onBlur={onBlur}
              onFocus={onFocus}
              autoComplete='off'
            />
            {value !== '' && (
              <span
                onClick={() => setShowPassword(!showPassword)}
                className='absolute right-2 md:top-3 top-1 w-[25px] h-[25px] 2xl:w-[30px] 2xl:h-[30px] cursor-pointer '
              >
                {showPassword ? <Eye width='100%' height='100%' color='#5D5F64' /> : <ClosedEye width='100%' height='100%' color='#5D5F64' />}
              </span>
            )}
          </div>
        ) : (
          <input
            required
            id={name}
            style={props.style}
            placeholder={placeholder}
            name={name}
            value={value}
            onChange={onChange}
            type={type}
            pattern={pattern}
            min={min}
            max={max}
            className={className}
            onBlur={onBlur}
            onFocus={onFocus}
            autoComplete='off'
          />
        )}
      </div>
    </>
  );
};

export default Input;
